// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/School/Detail/Admission.less
// module id = 907
// module chunks = 0